export interface Member {
	firstName?: string;
	lastName?: string;
	name: string;
}

// Get user initials
export const getInitials = (member: Member) => {
	if (member.firstName && member.lastName) {
		return `${member.firstName[0]}${member.lastName[0]}`.toUpperCase();
	}
	if (member.firstName) {
		return member.firstName[0].toUpperCase();
	}
	if (member.lastName) {
		return member.lastName[0].toUpperCase();
	}
	const words = member.name
		.trim()
		.split(/\s+/) // handle multiple spaces
		.slice(0, 3); // take only first 3 words

	return words
		.map(word => word[0])
		.join("")
		.toUpperCase();
};
